module.exports = __webpack_public_path__ + "img/category-casino-hover.b67e62b6.png";